"use strict";
// Dynamic title & favicon setup
const siteConfig = {
    "creative-workspace": {
        title: "Creative Workspace | Techolution",
        favicon: "/techolutionShortLogo.svg",
    },
    "appmod": {
        title: "AppMod | Techolution",
        favicon: "/Isotype.svg",
    },
    "cw": {
        title: "Creative Workspace | Techolution",
        favicon: "/techolutionShortLogo.svg",
    },
};
const defaultConfig = {
    title: "Techolution",
    favicon: "/techolutionShortLogo.svg",
};
const hostname = window.location.hostname.toLowerCase(); // case insensitive
const matchedConfig = Object.entries(siteConfig).find(([key]) => hostname.includes(key))?.[1] ||
    defaultConfig;
// Favicon setup
let favicon = document.querySelector("link[rel~='icon']");
if (!favicon) {
    favicon = document.createElement("link");
    favicon.setAttribute("rel", "icon");
    document.head.appendChild(favicon);
}
if (favicon instanceof HTMLLinkElement) {
    favicon.href = matchedConfig.favicon;
}
document.title = matchedConfig.title;
// Start your app
import("./bootstrap");
